function ordinal_suffix_of(s: string) {
  const i = parseInt(s, 10);
  const j = i % 10, k = i % 100;
  if (j == 1 && k != 11) {
    return i + "st";
  }
  if (j == 2 && k != 12) {
    return i + "nd";
  }
  if (j == 3 && k != 13) {
    return i + "rd";
  }
  return i + "th";
}
export const alumni_title = (lang: 'de' | 'en') => lang === 'en' ? "Alumni" : "Alumni";
export const staff_title = (lang: 'de' | 'en') => lang === 'en' ? "Team" : "Team";
export const staff_title_long = (lang: 'de' | 'en') => lang === 'en' ? "Institute Team" : "Institutsteam";
export const research_title = (lang: 'de' | 'en') => lang === 'en' ? "Research" : "Forschung"
export const research_title_long = (lang: 'de' | 'en') => lang === 'en' ? "Research" : "Forschung"
export const teaching_title = (lang: 'de' | 'en') => lang === 'en' ? "Teaching" : "Lehre"
export const teaching_title_long = (lang: 'de' | 'en') => lang === 'en' ? "Teaching" : "Lehre"
export const project_title = (lang: 'de' | 'en') => lang === 'en' ? "Projects" : "Projekte"
export const project_title_long = (lang: 'de' | 'en') => lang === 'en' ? "Research Projects" : "Forschungsprojekte"
export const project_old_title = (lang: 'de' | 'en') => lang === 'en' ? "Ended Projects" : "Abgeschlossene Projekte"
export const project_old_title_long = (lang: 'de' | 'en') => lang === 'en' ? "Ended Research Projects" : "Abgeschlossene Forschungsprojekte"
export const group_title = (lang: 'de' | 'en') => lang === 'en' ? "Labs" : "Gruppe"
export const group_title_long = (lang: 'de' | 'en') => lang === 'en' ? "Research Labs" : "Forschungsgruppen"
export const semester_title = (lang: 'de' | 'en') => lang === 'en' ? "Semester" : "Semester"
export const field_title = (lang: 'de' | 'en') => lang === 'en' ? "Fields" : "Felder"
export const field_title_long = (lang: 'de' | 'en') => lang === 'en' ? "Research Fields" : "Forschungsfelder"
export const link_more = (lang: 'de' | 'en') => lang === 'en' ? "Find out more..." : "Weiter lesen..."
export const floor = (level: string, lang: 'de' | 'en') => {
  if (lang === 'en') {
    if (level === '0') {
      return 'Ground Floor';
    } else {
      return ordinal_suffix_of(level) + ' Floor';
    }
  } else {
    if (level === '0') {
      return 'Erdgeschoss';
    } else {
      return `${level}. OG`;
    }
  }
};

export const trans = (lang: 'en' | 'de') => {
  const t = {
    en: {
      building: "Building",
      room: "Room",
      location: "Location",
      site_plan: "Site plan",
      floor_plan: "Floor plan",
      show_on_site_plan: "Show building on the site plan",
      show_on_floor_plan: "Show room on the floor plan",
      phone: "Phone",
      first_name: "Given Name",
      last_name: "Surname",
      publication: "Publications",
      start: "Start",
      end: "End",
      website: "Website",
      contact: "Contact",
      partner: "Partner",
    },
    de: {
      building: "Gebäude",
      room: "Raum",
      location: "Lage",
      site_plan: "Lageplan",
      floor_plan: "Etagenplan",
      show_on_site_plan: "Gebäude im Lageplan zeigen",
      show_on_floor_plan: "Raum im Etagenplan zeigen",
      phone: "Telefon",
      first_name: "Vorname",
      last_name: "Nachname",
      publication: "Veröffentlichungen",
      start: "Start",
      end: "Ende",
      website: "Webseite",
      contact: "Verantwortlicher",
      partner: "Partner",
    },
  }
  return t[lang]
}
// A project's own page (each has one since the projects became content pages); the
// old address was the projects page with the name after "#".
export const projectHref = (project: any, lang: string): string => project?.[`url_${lang}`] || '#';
// The teaser of a tile: the page's own, which the server takes from its text if none is set.
export const recordTeaser = (obj: any, lang: string): string | undefined => obj?.[`teaser_${lang}`] || undefined;

// The page of a research field or group, and its title as the pages show it (fields may carry a number in front: "P1. …").
export const recordHref = (record: any, lang: string): string => record?.[`url_${lang}`] || '#';
export const recordTitle = (record: any, lang: string): string => (record?.[`title_${lang}`] ?? record?.name ?? '').replace(/^P\d+\.\s*/, '');

// A team member's own page; the old address was the team page with the login after "#".
export const personHref = (user: any, lang: string): string => user?.[`url_${lang}`] || '#';
